import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Wrapper = styled.p(() =>
  mq({
    display: 'flex',
    alignItems: ['baseline', 'baseline', 'center', 'center'],
    fontSize: [
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
    ],
    fontWeight: 'bold',
    lineHeight: defaultTheme.font.height.base,
    marginRight: ['', '', defaultTheme.spacing.s, defaultTheme.spacing.s],
    marginBottom: [defaultTheme.spacing.s, defaultTheme.spacing.s, '0', '0'],
  }),
);

export const RaceNumber = styled.span(() =>
  mq({
    fontSize: defaultTheme.font.size.xl,
    lineHeight: '21px',
    marginRight: defaultTheme.spacing.xs,
  }),
);
